import { TransactionQueryKeys } from '@/modules/transaction/keys'
import {
	GetDepositTransactionsParams,
	DepositTransactionResponse,
} from '@/modules/transaction/types'
import { UnusedSkipTokenOptions } from '@tanstack/react-query'
import BankTransactionService from '../../services'

export const queryDepositTransactionOptions = (
	payload: GetDepositTransactionsParams,
	options?: UnusedSkipTokenOptions<DepositTransactionResponse>,
) => ({
	queryKey: [TransactionQueryKeys.DEPOSIT_TRANSACTION, payload],
	queryFn: () => BankTransactionService.getDepositTransactions(payload),
	...options,
})
